"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _draftJs = require("draft-js");

var _getFragmentFromSelection = _interopRequireDefault(require("draft-js/lib/getFragmentFromSelection"));

var _draftjsUtils = require("draftjs-utils");

var _icons = require("@ant-design/icons");

var _LinkSelector = _interopRequireDefault(require("../LinkSelector"));

var _utils = require("../../utils");

var _theme = require("../../theme");

var _templateObject;

var WysiwygLinkSelect = function WysiwygLinkSelect(props) {
  var editorState = props.editorState,
      onChange = props.onChange;

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      open = _ref3[0],
      setOpen = _ref3[1];

  var contentState = editorState.getCurrentContent();
  var startKey = editorState.getSelection().getStartKey();
  var startOffset = editorState.getSelection().getStartOffset();
  var blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
  var linkKey = blockWithLinkAtBeginning && blockWithLinkAtBeginning.getEntityAt(startOffset);
  var data = {
    title: '',
    utl: ''
  }; // If a link is selected we want to get the entire link text, whereas when a text is selected we just want the selection

  if (linkKey) {
    var linkInstance = contentState.getEntity(linkKey);

    if (linkInstance) {
      data = linkInstance.getData();
    }
  } else {
    var selectedText = (0, _getFragmentFromSelection.default)(editorState);
    data.title = selectedText ? selectedText.map(function (x) {
      return x.getText();
    }).join('\n') : '';
  }

  var handleChange = function handleChange(link) {
    if (link) {
      var title = link.title,
          url = link.url,
          target = link.target; // https://stackoverflow.com/a/63977337/14726146

      var selection = editorState.getSelection();
      var entityRange = (0, _draftjsUtils.getEntityRange)(editorState, (0, _draftjsUtils.getSelectionEntity)(editorState));

      if (entityRange) {
        var isBackward = selection.getIsBackward();

        if (isBackward) {
          selection = selection.merge({
            anchorOffset: entityRange.end,
            focusOffset: entityRange.start
          });
        } else {
          selection = selection.merge({
            anchorOffset: entityRange.start,
            focusOffset: entityRange.end
          });
        }
      }

      var _contentState = editorState.getCurrentContent();

      var newContentState, newEditorState; // Add or remove link depending on if url is provided

      if (url) {
        var contentStateWithEntity = _contentState.createEntity('LINK', 'MUTABLE', {
          target: target,
          url: url.includes('http') ? url : (0, _utils.formatSlug)(url, true),
          title: title
        });

        newContentState = _draftJs.Modifier.replaceText(_contentState, selection, title, editorState.getCurrentInlineStyle(), contentStateWithEntity.getLastCreatedEntityKey());
        newEditorState = _draftJs.EditorState.set(editorState, {
          currentContent: newContentState
        });
      } else {
        newContentState = _draftJs.Modifier.applyEntity(_contentState, selection, null);
        newEditorState = _draftJs.EditorState.push(editorState, newContentState, 'apply-entity');
      }

      onChange(newEditorState);
    }

    setOpen(false);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconContainer, {
    className: "rdw-dropdown-wrapper rdw-link-select",
    onClick: function onClick() {
      return setOpen(true);
    },
    active: !!data
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "rdw-dropdown-selectedtext"
  }, /*#__PURE__*/_react.default.createElement(_icons.LinkOutlined, null))), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: 'Link',
    visible: open,
    onCancel: function onCancel() {
      return setOpen(false);
    },
    width: 600,
    footer: null
  }, open && /*#__PURE__*/_react.default.createElement(_LinkSelector.default, {
    value: data,
    onChange: handleChange,
    removable: !!data.url
  })));
};

var IconContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref) {
  var active = _ref.active;
  return active ? _theme.colors.primary : 'inherit';
});

var _default = WysiwygLinkSelect;
exports.default = _default;